import { BridgeComponent } from "@hotwired/hotwire-native-bridge";

class CartUpdateComponent extends BridgeComponent {
    static component = "cartupdate";

    connect() {
        super.connect();
    }

    cartUpdate() {
        const cartCountEl = document.querySelector(
            ".wkfashion-mini-cart-count",
        );
        const cartCount = parseInt(cartCountEl?.textContent?.trim()) || 0;
        const quantity =
            parseInt(document.querySelector('[name="quantity"]')?.value) || 1;

        // This method can be used to trigger cart-related actions
        this.send(
            "cartupdate",
            { cart: parseInt(cartCount) + quantity },
            (response) => {
                console.log("📨 Cart action response:", response);
            },
        );
    }
}
export default CartUpdateComponent;
